// recon-bank-finish-messages translations (Spanish catalog).
window.PlummeI18n.register('es', {
  'rcb.finish.assertFailed': 'El extracto bancario aún no se puede conciliar.',
  'rcb.finish.archiveRejected': 'Se rechazó el archivado.',
  'rcb.finish.unhandledLines': 'Aún no se puede archivar: {count} movimiento(s) bancario(s) sin tratar por completo{label}{status}.',
  'rcb.finish.balanceDeviation': 'Aún no se puede archivar: la diferencia de saldo es {deviation} kr.',
  'rcb.finish.failed': 'No se pudo conciliar el extracto bancario.',
});
